import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5074f58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, null, -1))
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { class: "loginBox" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "线上考试系统")
], -1))
const _hoisted_6 = { class: "inps" }
const _hoisted_7 = { class: "inp" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "inp" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "btns" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("登录")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              class: "icon",
              src: require('../assets/avatar.png'),
              alt: ""
            }, null, 8, _hoisted_8),
            _createVNode(_component_el_input, {
              modelValue: _ctx.loginData.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginData.username) = $event)),
              placeholder: "请输入登录名"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              class: "icon",
              src: require('../assets/password.png'),
              alt: ""
            }, null, 8, _hoisted_10),
            _createVNode(_component_el_input, {
              modelValue: _ctx.loginData.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginData.password) = $event)),
              type: "password",
              placeholder: "请输入登录密码"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_button, {
            round: "",
            color: "#50212F",
            size: "large",
            onClick: _ctx.register
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ]))
}